export default function ($http) {
    return function (vehicleId, dealerId, enquiryId, model) {
        return $http.post(`api/vehicles/${vehicleId}/confirmation/${dealerId}/dealerConfirmationLetter/${enquiryId}`, model);
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/createLetter/createDealerConfirmationLetter.js